<template>
  <el-dialog :visible.sync="visible" :title="!dataForm.id ? $t('add') : $t('update')" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmitHandle()" label-width="120px">
     <div class="line-box" style="flex-wrap: wrap;">
      <el-form-item prop="name" :label="$t('dept.name')" class="styW">
        <el-input v-model="dataForm.name" :placeholder="$t('dept.name')"></el-input>
      </el-form-item>
      <el-form-item prop="parentName" :label="$t('dept.parentName')" class="dept-list styW" >
        <el-popover v-model="deptListVisible" ref="deptListPopover" placement="bottom-start" trigger="click">
          <el-tree
            :data="deptList"
            :props="{ label: 'name', children: 'children' }"
            node-key="id"
            ref="deptListTree"
            :highlight-current="true"
            :expand-on-click-node="false"
            accordion
            @current-change="deptListTreeCurrentChangeHandle">
          </el-tree>
        </el-popover>
        <el-input v-model="dataForm.parentName" v-popover:deptListPopover :readonly="true" :placeholder="$t('dept.parentName')">
          <i
            v-if="$store.state.user.superAdmin === 1 && dataForm.pid !== '0'"
            slot="suffix"
            @click.stop="deptListTreeSetDefaultHandle()"
            class="el-icon-circle-close el-input__icon">
          </i>
        </el-input>
      </el-form-item>
      <el-form-item prop="sort" :label="$t('dept.sort')"  class="styW">
        <el-input-number v-model="dataForm.sort" controls-position="right" :min="0" :label="$t('dept.sort')"></el-input-number>
      </el-form-item>
    </div>
    
    <div>
      <el-form-item  label="免密" prop="isNoPassword">
        <div style="display: flex;">
          <el-select :disabled="!dataForm.id ? true : false" v-model="dataForm.isNoPassword"  filterable  placeholder="请选择" >
            <el-option
              v-for="(item,index) in freeList"
              :key="index"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
          <div class="tip" v-if="dataForm.id">
            <img src="../../../assets/img/waring.svg" alt="">
            <span>此字段由技术部操作，请其他同事勿修改哦</span>
          </div>
        </div>
      </el-form-item>
    </div>
    <div>
      <el-form-item  label="流程方式" prop="methodId">
        <div style="display: flex;">
          <el-select :disabled="!dataForm.id ? true : false" v-model="dataForm.methodId"  filterable  placeholder="请选择" >
            <el-option
              v-for="(item,index) in flowList"
              :key="index"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
          <div class="tip" v-if="dataForm.id">
            <img src="../../../assets/img/waring.svg" alt="">
            <span>此字段由技术部操作，请其他同事勿修改哦</span>
          </div>
        </div>
      </el-form-item>
    </div>
      <el-form-item label="支付渠道" prop="payChannelId" :rules="{ required: true, message: $t('validate.required'), trigger: 'change' }">
        <el-select v-model="dataForm.payChannelId" placeholder="请选择">
          <el-option
            v-for="(item,index) in channelList"
            :key="index"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="状态" prop="payStatus" :rules="{ required: true, message: $t('validate.required'), trigger: 'change' }">
        <el-select v-model="dataForm.payStatus" placeholder="请选择">
          <el-option
            v-for="(item,index) in statusList"
            :key="index"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
       <el-form-item label="放款限额" prop="loanLimitEnabled" :rules="{ required: true, message: $t('validate.required'), trigger: 'change' }">
        <el-select @change="changeAmount()" v-model="dataForm.loanLimitEnabled" placeholder="请选择">
          <el-option
            v-for="(item,index) in isLimitList"
            :key="index"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="testAmountLimit" label="测试额度" class="styW11" v-if="dataForm.loanLimitEnabled == true">
        <div class="line-box" >
          <div class="ipt"> 0< 金额 <= </div>
          <el-input  v-model="dataForm.testAmountLimit" placeholder="请输入"></el-input>
          <div style="margin-left: 6px;">元</div>
        </div>
      </el-form-item>
      <el-form-item label="测试额度" class="styW11" v-else>
        <div class="line-box" >
          <el-input disabled  placeholder=">0"></el-input>
          <div style="margin-left: 6px;">元</div>
        </div>
      </el-form-item>
      <el-form-item prop="loanAmountMin" label="放款金额下限" class="styW11" v-if="dataForm.loanLimitEnabled == true">
        <div class="line-box" >
          <div style="min-width: 30px;"> >= </div>
          <el-input  v-model="dataForm.loanAmountMin" placeholder="请输入"></el-input>
          <div style="margin-left: 6px;">元</div>
        </div>
      </el-form-item>
      <el-form-item label="放款金额下限" class="styW11" v-else>
        <div class="line-box">
          <el-input disabled  placeholder=">0"></el-input>
          <div style="margin-left: 6px;">元</div>
        </div>
      </el-form-item>
    </el-form>
    <template slot="footer">
      <el-button @click="visible = false">{{ $t('cancel') }}</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()">{{ $t('confirm') }}</el-button>
    </template>
  </el-dialog>
</template>

<script>
import debounce from 'lodash/debounce'
export default {
  data () {
    return {
      visible: false,
      deptList: [],
      deptListVisible: false,
      freeList:[],
      flowList:[],
      statusList: [
        { value: 0, label: '启用' },
        { value: 1, label: '禁用' }
      ],
      isLimitList:[
        { value: false, label: '否' },
        { value: true, label: '是' }
      ],
      channelList:[],
      dataForm: {
        id: '',
        name: '',
        pid: '',
        parentName: '',
        sort: 0,
        isNoPassword:'否',
        methodId:'标准化',
        payChannelId:'',
        payStatus:'',
        loanLimitEnabled:false,
        testAmountLimit:'',
        loanAmountMin:''
      }
    }
  },
  computed: {
    dataRule () {
      return {
        name: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        parentName: [
          { required: true, message: this.$t('validate.required'), trigger: 'change' }
        ],
        testAmountLimit: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        loanAmountMin: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ]
      }
    }
  },
  created(){
    this.$http.get(`/sys/dict/data/list?dataType=FP`).then(r=>{
      this.freeList = r.data.data ? r.data.data.map(item => ({value:item.dictValue,label:item.dictLabel})) : []
    })
    this.$http.get(`/sys/dict/data/list?dataType=PM`).then(r=>{
      this.flowList = r.data.data ? r.data.data.map(item => ({value:item.dictValue,label:item.dictLabel})) : []
    })
    this.$http.get(`/sys/dict/data/list?dataType=pay_channel`).then(r=>{
        this.channelList = r.data.data ? r.data.data.map(item => ({value:item.dictValue,label:item.dictLabel})) : []
    })
  },
  methods: {
    init () {
      this.visible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].resetFields()
        this.getDeptList().then(() => {
          if (this.dataForm.id) {
            this.getInfo()
          } else if (this.$store.state.user.superAdmin === 1) {
            this.deptListTreeSetDefaultHandle()
          }
        })
      })
    },
    changeAmount(){
      console.log(21,this.dataForm.loanLimitEnabled);
      
      if(this.dataForm.loanLimitEnabled == false){
       delete this.dataForm.testAmountLimit
       delete this.dataForm.loanAmountMin
      }
    },
    // 获取部门列表
    getDeptList () {
      return this.$http.get('/sys/dept/list').then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.deptList = res.data
      }).catch(() => {})
    },
    // 获取信息
    getInfo () {
      this.$http.get(`/sys/dept/${this.dataForm.id}`).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.dataForm = {
          ...this.dataForm,
          ...res.data
        }
        this.dataForm.payChannelId = res.data.payChannelId.toString()
        console.log(32,this.dataForm);
        
        if(this.dataForm.isNoPassword == false){
          this.dataForm.isNoPassword = 'false'
        }else{
          this.dataForm.isNoPassword = 'true'
        }
        if (this.dataForm.pid === '0') {
          return this.deptListTreeSetDefaultHandle()
        }
        this.$refs.deptListTree.setCurrentKey(this.dataForm.pid)
      }).catch(() => {})
    },
    // 上级部门树, 设置默认值
    deptListTreeSetDefaultHandle () {
      this.dataForm.pid = '0'
      this.dataForm.parentName = this.$t('dept.parentNameDefault')
    },
    // 上级部门树, 选中
    deptListTreeCurrentChangeHandle (data) {
      this.dataForm.pid = data.id
      this.dataForm.parentName = data.name
      this.deptListVisible = false
    },
    // 表单提交
    dataFormSubmitHandle: debounce(function () {
      this.$refs['dataForm'].validate((valid) => {
        if (!valid) {
          return false
        }
        if(this.dataForm.isNoPassword == '否'){
          this.dataForm.isNoPassword = 'false'
        }
        if(this.dataForm.methodId == '标准化'){
          this.dataForm.methodId = '0'
        }
        this.$http[!this.dataForm.id ? 'post' : 'put']('/sys/dept', this.dataForm).then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              this.visible = false
              this.$emit('refreshDataList')
            }
          })
        }).catch(() => {})
      })
    }, 1000, { 'leading': true, 'trailing': false })
  }
}
</script>

<style lang="scss" scoped>
.mod-sys__dept {
  .dept-list {
    .el-input__inner,
    .el-input__suffix {
      cursor: pointer;
    }
  }
}
.tip{
  margin: 0 0 0 20px;
  color: #f59a23;
  img{
    width: 16px;
    margin-right: 8px;
  }
}
.styW11{
  width: 355px;
}
.ipt{
  min-width: 80px;
}
.line-box{
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
}
</style>
